import { RouteInfo } from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [
  {
    path: '/app/dashboard/',
    title: 'Dashboard',
    icon: 'mdi mdi-view-dashboard',
    class: '',
    label: '',
    labelClass: 'label pull-right',
    extralink: false,
    submenu: []
  },
  {
    path: '/webapps/',
    title: 'Transactions',
    icon: 'mdi mdi-square-inc-cash',
    class: 'has-arrow',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [
      { path: '/webapps/transactions/expenses', title: 'Expenses', icon: 'mdi mdi-chart-bar', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/webapps/transactions/income', title: 'Income', icon: 'mdi mdi-chart-histogram', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/webapps/transactions/mileage', title: 'Mileage', icon: 'mdi mdi-speedometer', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
    //  { path: '/webapps/transactions/reports', title: 'Reports', icon: 'mdi mdi-clipboard-text', class: '', label: '', labelClass: '', extralink: false, submenu: [] }
    ]
  },
  {
    path: '/webapps/files',
    title: 'Files',
    icon: 'mdi mdi-file',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: []
  },
  {
    path: '/webapps/properties',
    title: 'Properties',
    icon: 'mdi mdi-home-variant',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: []
  },
  {
    path: '/webapps/vehicle',
    title: 'Vehicle',
    icon: 'mdi mdi-car',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: []
  },
  {
    path: '/webapps/ticket',
    title: 'Maintenance',
    icon: 'fa fa-ticket',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: []
  },
  // {
  //   path: '/webapps/custom_agreement',
  //   title: 'Custom Lease',
  //   icon: 'mdi mdi-blogger',
  //   class: '',
  //   label: '',
  //   labelClass: '',
  //   extralink: false,
  //   submenu: []
  // }
];
